module.exports = __webpack_public_path__ + "static/media/menuicon.9975fabd.svg";